import { Editor } from 'grapesjs';
import {
  TRANSACTION_HISTORY_TABLE_V2_CLASSNAME,
  TransactionHistoryTableV2Renderer,
} from '@loyalty/editor-components';
import { faMedal } from '@fortawesome/pro-solid-svg-icons/faMedal';
import {
  AchievementsHistoryTableV2WidgetTraits,
  transactionHistoryTableV2WidgetTraits,
} from './TransactionHistoryTableV2WidgetTraits';
import { EditorComponentDefinition } from '../types';
import { EditorContext } from '../../../services/editor-service';
import { Toolbar, buildParticipantContextFromGrape } from '../../utils';

export const achievementsHistoryTableV2ComponentDefinition: EditorComponentDefinition = {
  id: 'transaction-history-table-v2',
  icon: faMedal,
  getLabel: ({ t }) => t('editor.component.achievements-history'),
  component: AchievementsHistoryTableV2Component,
  traits: {
    schema: transactionHistoryTableV2WidgetTraits,
    form: AchievementsHistoryTableV2WidgetTraits,
  },
  copyPasteHelper: element => {
    delete element.attributes.currencyIds;
  },
};

export function AchievementsHistoryTableV2Component(editor: Editor) {
  const i18n = editor.I18n;
  const context: EditorContext = editor.Config.context;
  const currencies = context.currencies;

  editor.DomComponents.addType(achievementsHistoryTableV2ComponentDefinition.id, {
    isComponent(el: HTMLElement) {
      return el.tagName === 'DIV' && el.classList.contains(TRANSACTION_HISTORY_TABLE_V2_CLASSNAME);
    },
    model: {
      defaults: {
        tagName: 'div',
        attributes: {
          currencyIds: currencies
            .filter(currency => !currency.deletedAt)
            .map(currency => currency.id),
          class: TRANSACTION_HISTORY_TABLE_V2_CLASSNAME,
        },
        name: 'achievements-history-table-v2',
        content: '',
        droppable: false,
        draggable: false,
        removable: false,
        copyable: false,
        traits: [],
      },
      initToolbar: Toolbar,
      init() {
        this.on('change:attributes', this.refresh);
      },
      refresh() {
        setTimeout(() => this.view?.onRender());
      },
      toHTML(): string {
        return TransactionHistoryTableV2Renderer(
          {
            state: context.widgetState,
            options: {
              id: this.getId(),
              attributes: this.getAttributes(),
              i18nAttributes: this.attributes.i18nAttributes || {},
            },
            context: buildParticipantContextFromGrape(i18n),
          },
          editor.Canvas.getDocument(),
        );
      },
    },
    view: {
      onRender() {
        const { el, model } = this;
        el.innerHTML = model.toHTML();
      },
    },
  });
}
